// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import reportReducer from './reports/reducer';
import filtereducer from './redux/reducer';
import screenReducer from './screen/reducer';
import timelineReducer from './BinReport/reducer';
import binBatchReducer  from './BinBatches/reducer';
const store = configureStore({
  reducer: {
    report: reportReducer, 
    filter: filtereducer, 
    screens: screenReducer,
    TimeLineReport: timelineReducer,
      binBatch: binBatchReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false, 
      serializableCheck: false, 
    }),
});

export default store;


